import UnauthorisedAccessPage from "../pages/unauthorisedAccessPage";
import { ProtectedRoute } from "./protectedRoutes";



const UnauthorisedRoutes = {
    path: '/unauthorized',
    element: <UnauthorisedAccessPage />,
    children: []
}


export default UnauthorisedRoutes;
